import Indexprincipal from './componentes/index.jsx'
import React, { useEffect } from 'react';
import './App.css';
import ReactGA from "react-ga4";
ReactGA.initialize("G-ZHP0N66K4N");


function App() {

  useEffect(() => {
    // 4. Disparamos la vista de página apenas carga el componente
    ReactGA.send({ 
      hitType: "pageview", 
      page: window.location.pathname + window.location.search,
      title: "Landing " + window.location.hostname // Esto ayuda a diferenciar Guanteo de Cardúmenes
    });
  }, []);

  return (
    <div className="App">
       <Indexprincipal/>
     
    </div>
  );
}

export default App;
